import { useState } from 'react';

const useClientValues = () => {
  const [eventData, setEventData] = useState({
    startClientX: 0,
    endClientX: 0,
    direction: null,
    isSwiping: false
  });
  const updateEventData = values =>
    setEventData(prevState => ({ ...prevState, ...values }));

  return [eventData, updateEventData];
};

export default useClientValues;
